import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const societyStatusGraph = createAsyncThunk("societyStatusGraph", async () => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const response = await AxiosInstance.get(
      `${API_KEY}/api/dashboard/chart/society-stats`, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        "Content-Type": "application/json",
       
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  societyStatusGraphData: null,
  isError: false,
  errorMessage: "",
};

const societyStatusGraphSlice = createSlice({
  name: "societyStatusGraph",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(societyStatusGraph.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(societyStatusGraph.fulfilled, (state, action) => {
      state.isLoading = false;
      state.societyStatusGraphData = action.payload;
    });
    builder.addCase(societyStatusGraph.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default societyStatusGraphSlice.reducer;
